import React, { useEffect } from 'react';

/**
 * Loads Inter font asynchronously to avoid render-blocking. The font is loaded
 * after initial paint, improving FCP and LCP metrics.
 */
const FontLoader = () => {
  useEffect(() => {
    const interLink = document.createElement('link');
    interLink.rel = 'stylesheet';
    interLink.href = 'https://rsms.me/inter/inter.css?v=4.1';
    document.head.appendChild(interLink);

    const displayLink = document.createElement('link');
    displayLink.rel = 'stylesheet';
    displayLink.href = 'https://fonts.googleapis.com/css2?family=DM+Serif+Display&display=swap';
    document.head.appendChild(displayLink);

    return () => {
      interLink.remove();
      displayLink.remove();
    };
  }, []);

  return null;
};

export default FontLoader;
